import { GENERIC_ERROR_MESSAGE } from '@zr/utilities/constants';
import { apiRequest } from '@zr/utilities/api';

const LICENSE_AUTOCOMPLETE_URL = '/license/autocomplete';

export async function fetchLicenseResults(term = '') {
  const uri = LICENSE_AUTOCOMPLETE_URL;
  try {
    const response = await apiRequest(uri, {}, term ? `?term=${term}` : '');
    const json = await response.json();

    if (!response.ok) {
      throw json;
    }

    return json.data.results;
  } catch (error) {
    const { stack } = error;
    const e = error;
    e.message = GENERIC_ERROR_MESSAGE;
    e.stack = stack;
    throw e;
  }
}

export default fetchLicenseResults;
